import { gql } from 'graphql-request';
import useSWRMutation from 'swr/mutation';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import { BasketFragment } from '@graphql/fragments';
import { basketRequest } from '@hooks/basket/_utils';
import { formatBasket, useBasketMutation } from '@hooks/basket/useBasket';
import { useCustomerIdToken } from '@hooks/customer';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { productAdded } from '@repo/ui/src/services/analytics';
import { gcToAnalytics } from '@repo/ui/src/services/analytics/factories';
import { GiftCard } from '@repo/ui/src/types/basket';
import { GraphQLRequestWithTokenProps } from '@repo/ui/src/utils/graphql-request';

export const addGiftCardToBasket = gql`
  ${BasketFragment}
  mutation AddGiftCard($item: AddGiftCardToBasketInput!) {
    addGiftCardToBasket(item: $item) {
      ...Basket
    }
  }
`;

interface Key extends GraphQLRequestWithTokenProps {
  productGeo: string;
  locale: string;
}
const fetcher = async (key: Key, { arg: item }: { arg: Omit<GiftCard, 'id'> }) => {
  const { addGiftCardToBasket: basket } = await basketRequest({
    ...key,
    variables: {
      item,
    },
  });
  productAdded({
    products: [gcToAnalytics(item)],
    basket_token: basket.basketJWT,
    affiliation: 'website',
    locale: key?.locale,
    brand: 'Traeger',
    cart_id: basket.id,
    currency: basket.currency,
  });
  return basket;
};
export const useAddGCToBasket = () => {
  const { locale, productGeo } = useCurrentUrl();
  const idToken = useCustomerIdToken();
  const mutate = useBasketMutation();
  const { push } = useModal(ModalID.cart);

  return useSWRMutation(
    {
      document: addGiftCardToBasket,
      locale,
      idToken,
      productGeo,
    },
    fetcher,
    {
      onSuccess: async (basket) => {
        const formattedBasket = formatBasket(basket, locale);
        await mutate(formattedBasket, { revalidate: false });
        push();
      },
    },
  );
};
